import React, { useEffect, useRef, useState } from 'react';
import { Flex, List, Typography, VerticalSpacing } from '@banhala/ui-kit';
import { GoodsInfoWebView } from './components/GoodsInfoWebView';
import { ContentContainer } from '../ContentContainer';
import { GoodsAtomicRenderer } from './components/AtomicRenderer';
import { RelatedOutfits } from './components/RelatedOutfits';
import { RelatedTags } from './components/RelatedTags';
import { LegalInfo } from './components/LegalInfo';
import { useElementViewportTracking } from '../../../../store/sectionVisibility';

export const GoodsInfoTab: React.FC<{
  focused: boolean;
  onChangeTabHeight: (height: number) => void;
}> = props => {
  const onChangeTabHeightRef = useRef(props.onChangeTabHeight);
  onChangeTabHeightRef.current = props.onChangeTabHeight;
  const trackingRef = useElementViewportTracking('atomic', 0);

  const [height, setHeight] = useState({
    info: 0,
    atomic: 0,
    legal: 0,
    codi: 0,
    tags: 0,
  });

  useEffect(() => {
    const nextHeight = Object.values<number>(height).reduce(
      (prev, acc) => prev + acc,
      0,
    );
    onChangeTabHeightRef.current(nextHeight);
  }, [height]);

  return (
    <ContentContainer focused={props.focused}>
      <List
        data={['info', 'atomic', 'codi', 'tags', 'legal']}
        keyExtractor={(item, index) => `${item}-${index}`.toString()}
        ListFooterComponent={<VerticalSpacing size={36} />}
        renderItem={({ item }) => {
          if (item === 'info') {
            return (
              <GoodsInfoWebView
                onChangeHeight={height => {
                  setHeight(prev => ({ ...prev, [item]: height }));
                }}
              />
            );
          }

          if (item === 'atomic') {
            return (
              <Flex ref={trackingRef}>
                <GoodsAtomicRenderer
                  screen={'GOODS_DETAIL'}
                  focused={props.focused}
                  onChangeHeight={height => {
                    setHeight(prev => ({ ...prev, [item]: height }));
                  }}
                />
              </Flex>
            );
          }

          if (item === 'codi') {
            return (
              <RelatedOutfits
                focused={props.focused}
                onChangeHeight={height => {
                  setHeight(prev => ({ ...prev, [item]: height }));
                }}
              />
            );
          }

          if (item === 'tags') {
            return (
              <RelatedTags
                onChangeHeight={height => {
                  setHeight(prev => ({ ...prev, [item]: height }));
                }}
              />
            );
          }

          if (item === 'legal') {
            return (
              <LegalInfo
                onChangeHeight={height => {
                  setHeight(prev => ({ ...prev, [item]: height }));
                }}
              />
            );
          }

          return (
            <Flex.Center height={300}>
              <Typography type={'subtitle2'}>{item}</Typography>
            </Flex.Center>
          );
        }}
      />
    </ContentContainer>
  );
};
